export const LastUpdated = '11 Mai 2026';
